/* eslint-disable prettier/prettier */
import { useEffect, useState, useCallback } from 'react';
import { userService, CoachProfile } from '../services/userService';

export function useCoachesList(
	type: 'coach' | 'mentor' = 'coach',
	filters?: {
		areasofexpertise?: string[];
		languages?: string[];
		minrating?: number;
		availability?: 'available' | 'limited' | 'full';
	}
) {
	const [coaches, setCoaches] = useState<CoachProfile[]>([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const fetchCoaches = useCallback(async () => {
		try {
			setLoading(true);
			setError(null);

			const data = await userService.getCoaches(type, filters);

			console.log('🎯 Hook Coaches:', data);

			setCoaches(data);
		} catch (err: any) {
			console.error('❌ Hook error:', err);
			setError(err.message || 'Failed to fetch coaches');
		} finally {
			setLoading(false);
		}
	}, [type, JSON.stringify(filters)]);

	useEffect(() => {
		fetchCoaches();
	}, [fetchCoaches]);

	return {
		coaches,
		loading,
		error,
		refetch: fetchCoaches,
	};
}
